import React from 'react';
import Layout from './layout';
import Appointments from './appointments';

const BranchManager = () => {
    return (
        <Layout>
            <div class="custom-tabs">
                <div style={{overflowX: 'auto',overflowY:'hidden', WebkitOverflowScrolling: 'touch'}}>
                    <ul class="nav nav-tabs" id="bmTab" role="tablist" style={{
                        backgroundColor:"#1ee576",
                        flexWrap: 'nowrap',
                        display: 'flex',
                        minWidth: 'max-content'
                    }}>
                        <li class="nav-item" role="presentation" style={{whiteSpace: 'nowrap'}}>
                            <button class="nav-link active" id="appointment-tab" data-bs-toggle="tab" data-bs-target="#appointments" type="button" role="tab" aria-controls="appointments" aria-selected="true">Appointments</button>
                        </li>
                    </ul>
                </div>
                <div class="tab-content" id="bmTabContent">
                    <div class="tab-pane fade show active" id="appointments" role="tabpanel" aria-labelledby="appointment-tab">
                        <Appointments />
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default BranchManager;